import { render, staticRenderFns } from "./DevicePreview.vue?vue&type=template&id=ea0d3064&scoped=true"
import script from "./DevicePreview.vue?vue&type=script&lang=js"
export * from "./DevicePreview.vue?vue&type=script&lang=js"
import style0 from "./DevicePreview.vue?vue&type=style&index=0&id=ea0d3064&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea0d3064",
  null
  
)

export default component.exports